import _ from 'lodash';
import { edgePoint } from '__editor/panelsEditor/components/roofZones/utils/edges';
import { state, dispatch } from '__common/store';
import { TOGGLE_OBSTRUCTIONS_ZONE, TOGGLE_WIND_ZONE } from './roofZonesActions';
import { isBlankMap } from '__common/constants/map';

// Re-exported from its previous home, so existing importers do not have to care
// that the geometry moved out of this module.
export { getRoofEdgesPxPoints } from '__editor/panelsEditor/geometry/setbackGeometry';

export const getRoofZonesEdges = (roofEdges: { x: number, y: number }[]): [edgePoint, edgePoint][] => {
  const { roofsSelector : { mapType }} = state();
  return roofEdges.reduce<[edgePoint, edgePoint][]>(
    (acc, coord, index) => {
      const nextCoord = roofEdges[index + 1] || roofEdges[0];
      // Only add the edge if current and next point are not equal
      if (isBlankMap(mapType) || !_.isEqual(coord, nextCoord)) {
          acc.push([coord, nextCoord]);
      }
      return acc;
    },                      
    [],
  );
};

export const getZoneDirection = (edge: edgePoint[]) => {
  const edgeWithZone = _.find(edge, (coord) => coord.zone && coord.zone.length > 0);
  if (edgeWithZone && edgeWithZone.zone) {
    return edgeWithZone.zone;
  }
};

export const enableObstructionsZoneView = () => {
  const { roofZones: { obstructionsZone } } = state();

  if (!obstructionsZone) {
    dispatch(TOGGLE_OBSTRUCTIONS_ZONE());
  }
};

export const disableObstructionZoneView = () => {
  const { roofZones: { obstructionsZone } } = state();

  if (obstructionsZone) {
    dispatch(TOGGLE_OBSTRUCTIONS_ZONE());
  }
};

export const disableWindZoneView = () => {
  const { roofZones: { windZone } } = state();

  if (windZone) {
    dispatch(TOGGLE_WIND_ZONE());
  }
};